module.exports = __webpack_public_path__ + "media/tape-nav/content-resource-center-icon-5efbe096.svg";